<template>
    <div class="container-fluid">
        <route-header>
            <h3>{{ $t('labels.nav.tasks') }}</h3>
            <div class="d-flex align-items-center">
                <bs-button v-if="auth.can['edit_tasks']" class="btn-sm btn-info" @click="$refs.tasks.create()">{{ $t('labels.action_task',  { action: $t('labels.create') }) }}</bs-button>
            </div>
        </route-header>
        <div class="row">
            <div class="col">
                <nav-secondary-tasks></nav-secondary-tasks>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <task-list ref="tasks" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Tasks',
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  }
}
</script>
